import React from 'react';
import { OwnerIdFragment, LensDownstreamOwnerIdsQuery, LensDownstreamOwnerIdsQueryVariables , LensDownstreamOwnerIdsDocument } from '../../../../../gen-src/queries';
import {
  DataCatalogApolloClient,
  getAllFromSliceable,
  GraphQLSliceable,
  HorizontalFlexContainer,
  MultiSelectionProvider,
  PaneTitle,
  Sliceable,
  VerticalFlexContainer
} from '../../../data-catalog-shared';
import { OwnersGridSortProvider } from '../sorting/sortProviders/OwnersGridSortProvider';
import { MultiSelectionControls } from '../widgets/MultiSelectionControls';
import { LensDownstreamOwnersQueryGrid } from './LensDownstreamOwnersQueryGrid';

export interface LensDownstreamOwnersPaneProps {
  readonly title: string;
  readonly vizportalUrlId: string;
  readonly rowCount: number | null;
}

export class LensDownstreamOwnersPane extends React.Component<LensDownstreamOwnersPaneProps> {

  public override render(): JSX.Element {
    return (
      <MultiSelectionProvider selectionId={this.props.vizportalUrlId}>
        {({ selectedKeys, setSelectedKeys, updateSelectionForKey }) =>
          <VerticalFlexContainer fillFlexParent={true}>
            <PaneTitle>
              <HorizontalFlexContainer>
                {this.props.title}
                {this.props.rowCount != null && this.props.rowCount > 0 ?
                  <>
                    <MultiSelectionControls
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      updateSelectionForKey={updateSelectionForKey}
                      fetchAllKeys={this.fetchAllOwnerKeys}
                    />
                    {/* TODO 1395149: Re-enable this button for 22.3 */}
                    {/* <ComposeEmailPaneButton
                      selectedUserIds={selectedKeys}
                      contentType='lens'
                      contentId={this.props.vizportalUrlId}
                    /> */}
                  </>
                  : null
                }
              </HorizontalFlexContainer>
            </PaneTitle>
            <OwnersGridSortProvider>
              {({ orderBy, updateSortOrder }) =>
                <LensDownstreamOwnersQueryGrid
                  vizportalUrlId={this.props.vizportalUrlId}
                  selectedKeys={selectedKeys}
                  updateSelectionForKey={updateSelectionForKey}
                  rowCount={this.props.rowCount}
                  orderBy={orderBy}
                  updateSortOrder={updateSortOrder}
                />
              }
            </OwnersGridSortProvider>
          </VerticalFlexContainer>
        }
      </MultiSelectionProvider>
    );
  }

  private readonly fetchAllOwnerKeys = async (client: DataCatalogApolloClient): Promise<ReadonlyArray<string>> => {
    const sliceable = this.createOwnerIdsSliceable(client);
    const items = await getAllFromSliceable(sliceable);
    return items.map(item => item.vizportalId);
  }

  private createOwnerIdsSliceable(client: DataCatalogApolloClient): Sliceable<OwnerIdFragment> {
    return new GraphQLSliceable<
      OwnerIdFragment,
      OwnerIdFragment,
      LensDownstreamOwnerIdsQueryVariables,
      LensDownstreamOwnerIdsQuery
    >({
      queryGql: LensDownstreamOwnerIdsDocument,
      selectConnectionListResult: (resultData) => {
        const lens = resultData.lenses && resultData.lenses[0];
        return lens.downstreamOwnersConnection;
      },
      mapResultNode: (node) => node,
    }, { vizportalUrlId: this.props.vizportalUrlId }, client);
  }

}
